import { z } from 'zod';
/**
 * Der Lesevertrag von `datev_mandant` — Migration `0186`, Chip `DX-mandant`.
 *
 * Spec `docs/superpowers/specs/2026-09-08-datev-export-design.md`, Abschnitt
 * 3.2 (`D-28`, `D-34`).
 *
 * **Kein Schreibvertrag.** Die Tabelle wird ausschliesslich von Migrationen
 * beschrieben (`D-28`), und `fameacc_app` hat nur `SELECT`. Ein Anlege- oder
 * Aenderungsschema waere ein Vertrag ueber einen Weg, den es nicht gibt —
 * dieselbe Erwaegung wie bei `packages/contracts/src/steuer/quelle.ts`.
 */
/** Ein Datum in ISO-Form (`JJJJ-MM-TT`), so wie es aus `date`-Spalten kommt. */
const isoDatumSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Erwartet wird ein Datum JJJJ-MM-TT.');
/**
 * Eine Zeile der Tabelle `datev_mandant`.
 *
 * `validTo` ist **ausschliessend**: Am Wechseltag zweier Fassungen gilt die
 * neue (`valid_from <= stichtag AND (valid_to IS NULL OR valid_to > stichtag)`).
 *
 * `wjBeginnMonat`/`wjBeginnTag` kommen als zwei Zahlen und nicht als
 * ISO-Datum: Die Datenbankspalte `wj_beginn` traegt ein festes
 * Referenzjahr (2000), das keine fachliche Bedeutung hat — wer das rohe
 * Datum weiterreichte, gaebe eine Behauptung ueber ein Jahr weiter, die
 * niemand gemeint hat. Der Vertrag zieht nur Monat und Tag heraus.
 */
export const datevMandantZeileSchema = z
    .object({
    beraternummer: z.number().int().min(1001).max(9999999),
    mandantennummer: z.number().int().min(1).max(99999),
    /** D-28: heute ausschliesslich `'SKR03'`. */
    skr: z.literal('SKR03'),
    /** 1–12. */
    wjBeginnMonat: z.number().int().min(1).max(12),
    /** 1–31, gueltig fuer den jeweiligen Monat (inkl. 29. Februar). */
    wjBeginnTag: z.number().int().min(1).max(31),
    /** 4–8, bei uns `4` (D-34). */
    sachkontenlaenge: z.number().int().min(4).max(8),
    validFrom: isoDatumSchema,
    validTo: isoDatumSchema.nullable(),
    fundstelle: z.string().min(1),
})
    .strict();
//# sourceMappingURL=mandant.js.map